<div class="tc-preview-main-container">
  <div *ngIf="!isComponentLoading && tcDetailsForParticularJob.length>0" class="container">

    <!-- Component Header Starts -->
    <div class="tc-preview-header">
      <img src="../../assets/img/tc-back-arrow.png" class="back-arrow" (click)="onBackArrowClick()" />
      <span class="service-number">#{{serviceId}}</span>
      <div class="search-bar">
        <img src="../../assets/img/tc-search-icon.png" alt="Search Icon" class="search-icon" />
        <input type="text" [placeholder]="'search' | translate" [(ngModel)]="searchValue" (blur)="handelOnBlurSearch()"
          (input)="filterParticularStudentTc()" class="search-input" />
      </div>
      <div class="button-group">
        <button class="email-button" (click)="openEmailModal();">
          {{'labelEmail' | translate }}
        </button>
        <button class="download-button" (click)="downloadZipFile();">
          {{'labelDownload' | translate }}
        </button>
      </div>
    </div>
    <!-- Component Header Ends -->

    <!-- Component Body Starts -->
    <div
      *ngIf="filteredTcDetailsForParticularJob && filteredTcDetailsForParticularJob.length>0 else showNoMatchedContentText"
      class="md-col-12 tc-preview-container">
      <div class="md-col-2" *ngFor="let tcDetails of filteredTcDetailsForParticularJob">
        <div class="image-container" (click)="viewParticularTcPreview(tcDetails)">
          <span *ngIf="tcDetails; then checkStatus else noDisplay"></span>
          <ng-template #checkStatus>
            <span *ngIf="tcDetails.isLatestTc && tcDetails.isDuplicate; else newTc">
              <span class="label">{{'labelDuplicated' | translate }}</span>
            </span>
          </ng-template>
          <ng-template #newTc>
            <span *ngIf="!tcDetails.isLatestTc; else noDisplay" class="label">
              {{'labelNewTcGenerated' | translate }}
            </span>
          </ng-template>
          <ng-template #noDisplay></ng-template>
          <img [src]="tcDetails.tcImageUrl" class="image-view" />
          <div class="student-name-box">{{tcDetails.studentName}}</div>
        </div>
      </div>
    </div>
    <ng-template #showNoMatchedContentText>
      <span class="no-matched-content">{{'noMatchedContentFound' | translate }}</span>
    </ng-template>
    <!-- Component Body Ends -->

    <!-- Show Particular TC UI Starts  -->
    <div *ngIf="showParticularTcPreview" class="modal-overlay" (click)="closeParticularTcPreviewPopup($event)">
      <img [ngClass]="{ 'hidden-arrow': currentIndex == 0 }" src="../../assets/img/tc-left-arrow.svg"
        class="tc-left-arrow tc-arrow" (click)="$event.stopPropagation(); navigateTc(-1);" />
      <div class="tc-preview-modal-content">
        <img [src]="selectedTcImageUrl" class="modal-image-viewer" (click)="$event.stopPropagation();" />
        <div class="tc-download-print-container">
          <img src="../../assets/img/tc-print.svg" class="tc-download-print-element"
            (click)="$event.stopPropagation(); printTc(selectedTcPdfUrl)" />
          <img src="../../assets/img/tc-download.svg" class="tc-download-print-element"
            (click)="$event.stopPropagation(); downloadPdfFile(selectedTcPdfUrl)" />
        </div>
      </div>
      <img [ngClass]="{ 'hidden-arrow': currentIndex == filteredTcDetailsForParticularJob.length - 1 }"
        src="../../assets/img/tc-right-arrow.svg" class="tc-right-arrow tc-arrow"
        (click)="$event.stopPropagation(); navigateTc(1);" />
    </div>
    <!-- Show Particular TC UI Ends -->

    <!-- Email Modal Starts -->
    <div class="email-modal-overlay" *ngIf="isEmailModalOpen">
      <div class="email-modal-content">
        <h2>{{'labelEmailSharing' | translate }}</h2>
        <label>{{'labelEmailId' | translate }}</label>
        <div class="email-email-input-wrapper" [ngClass]="{'no-margin-bottom': emailError}">
          <input type="email" [placeholder]="'enterEmailId' | translate" [(ngModel)]="email" />
          <button (click)="addEmail()" class="email-add-button" [disabled]="isEmailAddButtonDisabled">
            {{'labelAdd' | translate }}
          </button>
        </div>
        <div *ngIf="emailError" class="email-error-message">
          {{'emailErrorMessage' | translate }}
        </div>
        <div class="email-email-list">
          <div *ngFor="let email of emailList" class="email-email-tag">
            {{ email }}
            <button (click)="removeEmail(email)" class="email-remove-button" [disabled]="isEmailRemoveButtonDisabled">
              <img src="../../assets/img/tc-cancel-email-icon.svg" alt="Remove" class="email-remove-icon" />
            </button>
          </div>
        </div>
        <div class="email-modal-actions">
          <button (click)="closeEmailModal()" class="email-cancel-button">
            {{'labelCancel' | translate }}
          </button>
          <button (click)="sendTcOverEmail()" class="email-proceed-button">
            <div style="padding-top: 10px;" *ngIf="isEmailSending; else notLoadingProceedButton">
              <app-button-loader></app-button-loader>
            </div>
            <ng-template #notLoadingProceedButton>
              {{'labelProceed' | translate }}
            </ng-template>
          </button>
        </div>
      </div>
    </div>
    <!-- Email Modal Ends -->

  </div>
  <span class="no-tc-avialable" *ngIf="!isComponentLoading && tcDetailsForParticularJob.length==0 ">
    {{'noTcPreviewAvailable' | translate }}
  </span>
  <div *ngIf="isComponentLoading" class="app-loader">
    <app-new-loader></app-new-loader>
  </div>

</div>